import {DailyGameState} from './DailyGameStore.types';

export const DAILY_GAME_STORE_INITIAL_STATE: DailyGameState = {
  config: {
    keyboardSymbols: [],
    reward: 0,
    cta: {
      text: '',
      link: '',
      deeplink: '',
      investDeeplink: '',
    },
    cipherLength: 0,
  },
  inputCipher: [],
  showResultModal: false,
  cipher: '',
  isWasFails: false,
};

export const CIPHER_DAILY_REVERT_TO_IDLE_TIME = 500;
